import { SelectField } from "$components/rhf-fields";
import { usePatientLanguageTranslation } from "$routes/_lib/use-language-translation";
import { useIntl } from "react-intl";

export const LanguageSelectInput: FC<{
  name: string;
  label?: string;
  dataTestId?: string;
}> = ({
  dataTestId = "patientRegistrationLanguage",
  label: labelOverride,
  ...delegateProps
}) => {
  const { languages } = usePatientLanguageTranslation();

  const { formatMessage } = useIntl();
  const label =
    labelOverride ||
    formatMessage({
      id: "patient.additionalInfo.languageSelect.label",
      defaultMessage: "Language",
    });

  return (
    <SelectField
      fullWidth
      name={name}
      data-testid={dataTestId}
      {...delegateProps}
      label={label}
      options={languages.map(({ name, code }) => ({
        label: name,
        value: code,
      }))}
    />
  );
};
